/*
 * Ampliar a pack (upsell en carrito).
 *
 * Reemplaza al antiguo window.cartPackUpsell (que hacia add.js -> change.js
 * y fallaba con 400 porque el cart transform regeneraba la clave de la linea
 * suelta tras el add). Aqui:
 *   1) se QUITA primero la linea suelta (clave valida, aun sin transformar)
 *   2) se ANADE despues el pack del sabor elegido
 * y si el add falla se hace rollback re-anadiendo la linea suelta.
 *
 * Usa delegacion de eventos en document, asi que sobrevive a los morphs del
 * drawer/carrito sin re-enlazar nada. Se inicializa una sola vez.
 */
(function () {
  if (window.__cartPackUpsellReady) return;
  window.__cartPackUpsellReady = true;

  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function collectSectionsParam() {
    var set = {};
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      if (c.dataset.sectionId) set[c.dataset.sectionId] = true;
    });
    document.querySelectorAll('cart-icon').forEach(function (c) {
      var sec = c.closest('[id^="shopify-section-"]');
      if (sec) set[sec.id.replace('shopify-section-', '')] = true;
    });
    return Object.keys(set).join(',');
  }

  async function refreshCart(param) {
    var itemCount = null;
    var sections = null;
    try {
      var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      itemCount = cart.item_count;
    } catch (e) {}
    if (param) {
      try {
        var res = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(param), {
          headers: { Accept: 'application/json' }
        });
        if (res.ok) sections = await res.json();
      } catch (e) {}
    }
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { itemCount: itemCount, source: 'pack-upsell', sections: sections } }
      })
    );
  }

  function togglePanel(btn) {
    var container = btn.closest('.cart-pack-upsell');
    if (!container) return;
    var panel = container.querySelector('.cart-pack-upsell__panel');
    if (!panel) return;
    var open = !panel.hasAttribute('hidden');
    if (open) {
      panel.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', 'false');
    } else {
      panel.removeAttribute('hidden');
      btn.setAttribute('aria-expanded', 'true');
    }
  }

  async function selectFlavor(el) {
    var container = el.closest('.cart-pack-upsell');
    if (!container || container.dataset.busy === 'true') return;

    var lineKey = container.dataset.lineKey;
    var looseVariant = parseInt(container.dataset.looseVariant, 10);
    var looseQty = parseInt(container.dataset.looseQty, 10) || 1;
    var variantId = parseInt(el.dataset.variantId, 10);
    if (!lineKey || !variantId) return;

    container.dataset.busy = 'true';
    var buttons = container.querySelectorAll('button');
    buttons.forEach(function (b) { b.disabled = true; });
    el.classList.add('is-loading');

    var param = collectSectionsParam();

    var undo = function () {
      container.dataset.busy = 'false';
      buttons.forEach(function (b) { b.disabled = false; });
      el.classList.remove('is-loading');
    };

    try {
      // 1) Quitar la linea suelta primero (su clave aun es valida).
      var rmRes = await fetch('/cart/change.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      });
      if (!rmRes.ok) {
        var re = await rmRes.json().catch(function () { return {}; });
        console.error('[pack-upsell] no se pudo quitar la linea suelta:', rmRes.status, re);
        undo();
        return;
      }

      // 2) Anadir el pack del sabor elegido.
      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!addRes.ok) {
        var ae = await addRes.json().catch(function () { return {}; });
        console.error('[pack-upsell] add fallo, revirtiendo:', addRes.status, ae);
        // Rollback: devolver la linea suelta al carrito.
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: JSON_HEADERS,
          body: JSON.stringify({ items: [{ id: looseVariant, quantity: looseQty }] })
        }).catch(function () {});
        undo();
        return;
      }

      await refreshCart(param);
      // El morph elimina este nodo; no hace falta restaurar estado.
    } catch (err) {
      console.error('[pack-upsell]', err);
      undo();
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-pack-upsell-btn');
    if (btn && btn.closest('.cart-pack-upsell')) {
      if (btn.hasAttribute('data-upsell-toggle')) {
        togglePanel(btn);
      } else if (btn.dataset.variantId) {
        e.preventDefault();
        selectFlavor(btn);
      }
      return;
    }
    var flavor = e.target.closest('.cart-pack-upsell__flavor');
    if (flavor) {
      e.preventDefault();
      selectFlavor(flavor);
    }
  });
})();
